import BtLe from "@/lib/printer/BtLe";

export default {
    transport() {
        return 'BtLe'
    },

    can() {
        return BtLe.can();
    },

    async print(config, printText, copies) {
        for (let i = 0; i < copies; i++) {
            await BtLe.send(config.name, printText, '38eb4a80-c570-11e3-9507-0002a5d5c51b', '38eb4a82-c570-11e3-9507-0002a5d5c51b')
        }

        return this.transport()
    }
}